'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _alignments = require('../../constants/alignments');

var _colors = require('../../constants/colors');

var _sizes = require('../../constants/sizes');

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _bullet = require('../lists/bullet');

var _bullet2 = _interopRequireDefault(_bullet);

var _genericModal = require('../../organisms/modals/genericModal');

var _genericModal2 = _interopRequireDefault(_genericModal);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _splash = require('../../layouts/splash');

var _splash2 = _interopRequireDefault(_splash);

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _error = require('../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OperationMessages = function (_React$Component) {
    _inherits(OperationMessages, _React$Component);

    function OperationMessages(props) {
        _classCallCheck(this, OperationMessages);

        var _this = _possibleConstructorReturn(this, (OperationMessages.__proto__ || Object.getPrototypeOf(OperationMessages)).call(this, props));

        _this.getIcon = function (hasErrors, primary) {
            var icon = hasErrors ? _react2.default.createElement(_error2.default, { size: 48 }) : _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: '48', height: '48', viewBox: '0 0 48 48' },
                _react2.default.createElement('rect', { fill: 'transparent', width: '48', height: '48' }),
                _react2.default.createElement('circle', { cx: '20', cy: '20', r: '20', transform: 'translate(4 4)', fill: primary, opacity: '0.3' }),
                _react2.default.createElement('rect', { width: '4', height: '14', rx: '2', transform: 'translate(22 20)', fill: primary }),
                _react2.default.createElement('rect', { width: '4', height: '4', rx: '2', transform: 'translate(22 14)', fill: primary })
            );
            return icon;
        };

        _this.getMessages = function () {
            var messages = [];

            if (_this.props.operation) {
                var hasErrors = _this.props.operation.errors && _this.props.operation.errors.length > 0;
                var hasWarnings = _this.props.displayWarnings && _this.props.operation.warnings && _this.props.operation.warnings.length > 0;

                if (hasErrors) {
                    _this.props.operation.errors.forEach(function (item) {
                        return messages.push({ code: item.code, value: item.value ? item.value : item.code, isError: true });
                    });
                }

                if (hasWarnings) {
                    _this.props.operation.warnings.forEach(function (item) {
                        return messages.push({ code: item.code, value: item.value ? item.value : item.code, isError: false });
                    });
                }
            }

            return messages;
        };

        _this.getModalContent = function (messages) {
            var content = [];

            if (messages.length > 0) {
                content.push(_react2.default.createElement(_header2.default, {
                    size: _sizes.Sizes.md,
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'OperationMessages.oops' })
                }));
                content.push(_react2.default.createElement(_bullet2.default, { references: messages }));
            }

            return content;
        };

        _this.getPanelContent = function (messages) {

            var hasErrors = _this.props.operation.errors && _this.props.operation.errors.length > 0;

            var color = hasErrors ? _colors.Colors.Error : _colors.Colors.Secondary;

            var content = [];

            if (messages.length > 0) {
                content.push(_react2.default.createElement(
                    _grid2.default,
                    null,
                    _react2.default.createElement(
                        _row2.default,
                        null,
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 12, md: 1, lg: 2 },
                            _react2.default.createElement(
                                _container2.default,
                                { fullsize: true, horizontalAlignment: _this.context.screen.isMobile ? _alignments.Alignments.center : _alignments.Alignments.right, verticalAlignment: _alignments.Alignments.top },
                                _react2.default.createElement(
                                    _container2.default,
                                    null,
                                    _this.getIcon(hasErrors, color)
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 12, md: 11, lg: 10 },
                            _react2.default.createElement(
                                _container2.default,
                                { fullSize: true,
                                    verticalAlignment: _alignments.Alignments.center
                                },
                                _react2.default.createElement(_bullet2.default, { references: messages,
                                    textAlign: _this.context.screen.isMobile ? _alignments.Alignments.center : _alignments.Alignments.left,
                                    top: _this.context.screen.isMobile ? _sizes.Sizes.xs : _sizes.Sizes.none,
                                    bottom: _this.context.screen.isMobile ? _sizes.Sizes.xs : _sizes.Sizes.none,
                                    left: _this.context.screen.isMobile ? _sizes.Sizes.xs : _sizes.Sizes.none,
                                    right: _this.context.screen.isMobile ? _sizes.Sizes.xs : _sizes.Sizes.none,
                                    hideListSymbol: true,
                                    color: color })
                            )
                        )
                    )
                ));
            }

            return content;
        };

        _this.getModal = function () {
            return _react2.default.createElement(_genericModal2.default, {
                animate: true,
                size: _sizes.Sizes.md,
                visible: !_this.state.closed,
                displayWarnings: _this.props.displayWarnings,
                closeEvent: function closeEvent() {
                    _this.setState({ closedOn: _this.props.operation.createdOn });
                },
                items: _this.getModalContent(_this.getMessages()),
                actionButtons: [{
                    primary: true,
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'OperationMessages.ok' }),
                    clickEvent: function clickEvent() {
                        return _this.setState({ closedOn: _this.props.operation.createdOn });
                    }
                }]
            });
        };

        _this.getPanel = function () {
            var hasErrors = _this.props.operation.errors && _this.props.operation.errors.length > 0;

            var color = hasErrors ? _colors.Colors.Error : _colors.Colors.Secondary;

            return _react2.default.createElement(
                _splash2.default,
                { color: (0, _getColor2.default)(color, _opacity2.default.Lighter) },
                _react2.default.createElement(
                    _container2.default,
                    { color: (0, _getColor2.default)(color, _opacity2.default.Lighter) },
                    _this.getPanelContent(_this.getMessages())
                )
            );
        };

        _this.state = {
            closedOn: null
        };
        return _this;
    }

    _createClass(OperationMessages, [{
        key: 'render',
        value: function render() {
            if (!this.props.operation || this.props.operation && !this.props.operation.errors && !this.props.operation.warnings && !this.props.operation.confirmations) {
                return null;
            }
            if (this.state.closedOn === this.props.operation.createdOn) {
                return null;
            }
            return this.props.mode && this.props.mode === 'panel' ? this.getPanel() : this.getModal();
        }
    }]);

    return OperationMessages;
}(_react2.default.Component);

OperationMessages.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = OperationMessages;